import { STYLE_PRESETS } from '@/lib/constants/presets';
import { useFormattingStore } from '@/stores/formattingStore';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';

export function StylePresets() {
  const applyPreset = useFormattingStore((s) => s.applyPreset);

  return (
    <Card className="mt-6">
      <h3 className="text-lg font-serif font-medium mb-4">Style Presets</h3>
      <div className="flex flex-col gap-2">
        {Object.values(STYLE_PRESETS).map((preset) => (
          <Button
            key={preset.name}
            variant="ghost"
            className="justify-between h-auto py-3 px-4 border border-border hover:border-primary/50 bg-background hover:bg-card transition-all text-left"
            onClick={() => applyPreset(preset)}
          >
            <div>
              <div className="font-medium text-text-primary">{preset.name}</div>
              <div className="text-xs text-text-secondary font-normal">{preset.description}</div>
            </div>
            <span className="text-xl">✨</span>
          </Button>
        ))}
      </div>
    </Card>
  );
}
